"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    picker: {
        height: 45,
        fontFamily: 'Arial',
        borderRadius: 0,
        fontSize: 16,
        padding: 12,
        flex: 1,
    },
    searchBar: {
        height: 45,
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        backgroundColor: colors_1.default.WHITE,
        borderRadius: 0,
        flex: 3,
        minWidth: 300,
    },
});
exports.default = styles;
